import React from "react"
import { CardElement } from "react-stripe-elements"
import glamorous from "glamorous"
import style from "utils/style"

class CardSection extends React.Component {
  render() {
    return (
      <Label>
        Card details
        <CardElement style={{ base: { fontSize: "18px" } }} />
      </Label>
    )
  }
}

export default CardSection

const Label = glamorous.div({
  fontWeight: "700",
  color: style.colors.almostBlack,
})



// WEBPACK FOOTER //
// ./src/scenes/Camp/CampBilling/card-section.js